var render = function render(){var _vm=this,_c=_vm._self._c;return _c('line-chart',{attrs:{"id":"chart","options":_vm.lineChartOptions,"data":_vm.LineChartData,"plugins":_vm.plugins}})
}
var staticRenderFns = []

export { render, staticRenderFns }